export const DeleteUserActionTypes = {
  DELETE_USER_LOADING: "DELETE_USER_LOADING",
  DELETE_USER_ERROR: "DELETE_USER_ERROR",
  DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",
};
